import React, { useEffect, useState } from "react";
import config from "../config";
import "../styles/billing.css";
import Home from "../assets/SVG/buttons/Home-button-big.svg";
import MUIDataTable from "mui-datatables";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerByUid, getInvoicesByCustomer, getPaymentsByCustomer, getRevenueCatSubscriberByUid, getStripeCustomer } from "../api";
import Profile from "../assets/SVG/icons/Avatar.svg";
import Logout from "../assets/SVG/buttons/logout.svg";
import * as action from "../actions";
import axios from "axios";
import "../styles/payments.css";
import moment from "moment-timezone";
import { useHistory } from "react-router-dom";
import { TableFooter } from "@mui/material";

const PAYMENT_OPTION = {
  INVOICE: "INVOICE",
  TRANSACTION: "TRANSACTION",
};

const Account = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const [stripeCustomer, setStripeCustomer] = useState();
  const [managementUrl, setManagementUrl] = useState();

  const [invoices, setInvoices] = useState();
  const [invoicesPerPageLimit, setInvoicesPerPageLimit] = useState(10);
  const [invoicesNextPageId, setInvoicesNextPageId] = useState();
  const [hasMoreInvoices, setHasMoreInvoices] = useState();

  const [payments, setPayments] = useState();
  const [paymentsPerPageLimit, setPaymentsPerPageLimit] = useState(10);
  const [paymentsNextPageId, setPaymentsNextPageId] = useState();
  const [hasMorePayments, setHasMorePayments] = useState();

  const [isLoading, setIsLoading] = useState(true);
  const [activeOption, setActiveOption] = useState(PAYMENT_OPTION.INVOICE);

  const handleLogout = () => {
    axios
      .get(config.backend_url + "/logout")
      .then(function (response) {
        history.push("/login");
        dispatch(action.logoutUser());
      })
      .catch(function (error) {
        console.error(error);
      });
  };
  const gotoPayInvoice = (invoiceId) => {
    history.push(`/invoice/${invoiceId}`);
  };

  const fetchNextInvoices = async () => {
    const getInvoiceResp = await getInvoicesByCustomer(stripeCustomer?.id, invoicesPerPageLimit, invoicesNextPageId);
    setInvoices((prevState) => {
      return [...prevState, ...getInvoiceResp?.invoices?.data];
    });
    setInvoicesNextPageId(getInvoiceResp?.invoices?.next_page);
    setHasMoreInvoices(getInvoiceResp?.invoices?.has_more);
  };

  const fetchNextPayments = async () => {
    const getPaymentResp = await getPaymentsByCustomer(stripeCustomer?.id, paymentsPerPageLimit, paymentsNextPageId);
    setPayments((prevState) => [...prevState, ...getPaymentResp?.payments?.data]);
    setPaymentsNextPageId(getPaymentResp?.payments?.next_page);
    setHasMorePayments(getPaymentResp?.payments?.has_more);
  };

  const paymentsTableColumns = [
    {
      name: "product_detail",
      label: "Product",
      sort: false,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          return val?.name;
        },
      },
    },
    {
      name: "created",
      label: "Created At",
      sort: false,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          const formatDate = moment.unix(val).format("ll");
          return formatDate;
        },
      },
    },
    {
      name: "currency",
      label: "Currency",
      sort: false,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          return val.toUpperCase();
        },
      },
    },
    {
      name: "amount",
      label: "Amount",
      sort: false,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          return val / 100;
        },
      },
    },
    {
      name: "status",
      label: "Status",
      sort: false,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          return <div className="payment-status">{val}</div>;
        },
      },
    },
    {
      name: "payment_method",
      label: "Payment Method",
      sort: false,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          if (val?.card) {
            return (
              <div className="payment-method">
                <span className="payment-method-brand">{val?.card?.brand}</span> ending {val?.card?.last4}
              </div>
            );
          }
          return "Other";
        },
      },
    },
  ];
  const invoiceTableColumns = [
    {
      name: "product_detail",
      label: "Product",
      sort: false,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          return val?.name;
        },
      },
    },
    {
      name: "id",
      label: "Invoice Id",
      sort: false,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "created",
      label: "Created At",
      sort: false,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          const formatDate = moment.unix(val).format("ll");
          return formatDate;
        },
      },
    },
    {
      name: "currency",
      label: "Currency",
      sort: false,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          return val.toUpperCase();
        },
      },
    },
    {
      name: "amount_due",
      label: "Amount",
      sort: false,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          return val / 100;
        },
      },
    },
    {
      name: "paid",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val, tableMeta, updateValue) => {
          // return val === true ? "Paid" : "Unpaid";
          return val === true ? (
            <div className="invoice-status" data-testid="invoice-status">
              Paid
            </div>
          ) : (
            <div className="invoice-status" data-testid="invoice-status">
              <div>Unpaid</div>
              <div
                className="invoice-status-pay"
                data-testid="invoice-status-pay"
                onClick={() => gotoPayInvoice(tableMeta?.rowData[1])}
              >
                Pay
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "invoice_pdf",
      label: "Download",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (val) => {
          return (
            <a className="download-invoice" href={val} open="_blank">
              Download
            </a>
          );
        },
      },
    },
  ];

  const InvoiceTableOptions = {
    filter: false,
    print: false,
    download: false,
    search: false,
    viewColumns: false,
    pagination: false,
    serverSide: true,
    selectableRows: "none",
    sortOrder: {},
    responsive: "simple",
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          break;
        case "sort":
          break;
        case "changeRowsPerPage":
          break;
        case "search":
          break;
        default:
      }
    },
    onDownload: () => {
      // Need to return false disable default download from DataTable
      return false;
    },
    customToolbar: () => {},
    customFooter: () => (
      <TableFooter
        className="invoices-pagination-custom-footer"
        style={{ display: "inherit" }}
        data-testid="invoice-table-footer"
      >
        {hasMoreInvoices && (
          <div className="custom-footer-text" onClick={fetchNextInvoices}>
            Load More
          </div>
        )}
      </TableFooter>
    ),
    onRowClick: (rowData) => {},
  };
  const PaymentTableOptions = {
    filter: false,
    print: false,
    download: false,
    serverSide: true,
    count: payments?.length || 0,
    // rowsPerPage: 10,
    selectableRows: "none",
    // rowsPerPageOptions: [10, 15, 20],
    sortOrder: {},
    responsive: "standard",
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          break;
        case "sort":
          break;
        case "changeRowsPerPage":
          break;
        case "search":
          break;
        default:
      }
    },
    onDownload: () => {
      // Need to return false disable default download from DataTable
      return false;
    },
    customToolbar: () => {},
    customFooter: () => (
      <TableFooter
        className="invoices-pagination-custom-footer"
        style={{ display: "inherit" }}
        data-testid="payment-table-footer"
      >
        {hasMorePayments && (
          <div className="custom-footer-text" onClick={fetchNextPayments}>
            Load More
          </div>
        )}
      </TableFooter>
    ),
    onRowClick: (rowData) => {},
  };
  useEffect(() => {
    // Check if Stripe customer exist | if not create one
    getCustomerByUid(user.uid).then(async (res) => {
      // Get the stripe customer object
      if (res.customer) {
        setStripeCustomer(res.customer);
        const stripeCustomerResp = await getStripeCustomer(res.customer?.customerId);
        setStripeCustomer(stripeCustomerResp.stripeCustomer);

        const getInvoiceResp = await getInvoicesByCustomer(
          res.customer?.customerId,
          invoicesPerPageLimit,
          invoicesNextPageId
        );
        setInvoices(getInvoiceResp?.invoices?.data);
        setInvoicesNextPageId(getInvoiceResp?.invoices?.next_page);
        setHasMoreInvoices(getInvoiceResp?.invoices?.has_more);

        const getPaymentsResp = await getPaymentsByCustomer(
          res.customer?.customerId,
          paymentsPerPageLimit,
          paymentsNextPageId
        );
        setPayments(getPaymentsResp?.payments?.data);
        setPaymentsNextPageId(getPaymentsResp?.payments?.next_page);
        setHasMorePayments(getPaymentsResp?.payments?.has_more);

        // Fetch all
      } else {
        // Show no any accounts and invoices.
      }
      setIsLoading(false);
    });
    getRevenueCatSubscriberByUid(user.uid).then( async (res) => {
      setManagementUrl(res?.subscriber?.management_url || '#');
    })
  }, []);

  if (user?.hasRevenueCatSub) {
    return (
      <div className="container">
        <div className="main navigation" data-testid="navigation">
          <div className="header mt-3">
            <img src={Home} alt="home" onClick={() => history.push("/home")}></img>
            <img
              src={user?.picture ? user.picture : Profile}
              alt="profile"
              className="profile mt-4"
              onClick={() => history.push("/navigation")}
            ></img>
            <img src={Logout} alt="logout" onClick={handleLogout}></img>
          </div>
          <p className="text-center mt-3 heading">Payments</p>
          {/* TODO: May be redirect to mobile app plan view/page */}
          <div>Please go to Mobile app for payment details: </div>
          <a className="go-to-platform-subscription" href={managementUrl} target="_blank">
            Click here
          </a>
        </div>
      </div>
    );
  }
  return (
    <div className="container">
      <div className="main navigation" data-testid="navigation">
        <div className="header mt-3">
          <img src={Home} alt="home" onClick={() => history.push("/home")}></img>
          <img
            src={user?.picture ? user.picture : Profile}
            alt="profile"
            className="profile mt-4"
            onClick={() => history.push("/navigation")}
          ></img>
          <img src={Logout} alt="logout" onClick={handleLogout}></img>
        </div>
        <p className="text-center mt-3 heading">Payments</p>
        {isLoading ? (
          <div id="cover-spin"></div>
        ) : (
          <div className="wrapper" data-testid="wrapper">
            <div className="payment-options">
              <div className="payment-options-container">
                <button
                  data-testid="invoice-button"
                  className={`invoice-button ${
                    activeOption === PAYMENT_OPTION.INVOICE ? "active-payment" : "inactive-payment"
                  }`}
                  onClick={() => setActiveOption(PAYMENT_OPTION.INVOICE)}
                >
                  Invoices
                </button>
                <button
                  data-testid="transaction-button"
                  className={`transaction-button ${
                    activeOption === PAYMENT_OPTION.TRANSACTION ? "active-payment" : "inactive-payment"
                  }`}
                  onClick={() => setActiveOption(PAYMENT_OPTION.TRANSACTION)}
                >
                  Transactions
                </button>
              </div>
              {activeOption === PAYMENT_OPTION.INVOICE && (
                <div>
                  <div className="invoice-datatable-container" data-testid="invoice-table-container">
                    <MUIDataTable data={invoices} columns={invoiceTableColumns} options={InvoiceTableOptions} />
                  </div>
                </div>
              )}
              {activeOption === PAYMENT_OPTION.TRANSACTION && (
                <div>
                  <div className="invoice-datatable-container" data-testid="transaction-table-container">
                    <MUIDataTable data={payments} columns={paymentsTableColumns} options={PaymentTableOptions} />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Account;
